import * as React from 'react';
import S from './SectionWrapper.styles';
const SectionWrapper = React.forwardRef(({ children, layout = 'default', spacing = 'margin', hideOverflow, id, ...otherProps }, ref) => {
    switch (layout) {
        case 'fullWidth':
            return (React.createElement(S.Container, { id: id ? id : undefined, ref: ref, "data-spacing": spacing, "data-hide-overflow": hideOverflow, ...otherProps }, children));
        case 'default':
        default:
            return (React.createElement(S.Container, { id: id ? id : undefined, ref: ref, "data-spacing": spacing, "data-hide-overflow": hideOverflow, ...otherProps },
                React.createElement(S.Inner, null, children)));
    }
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
